import { Button } from '@/components/ui/button';
import { supabase } from '@/lib/supabase';
import { clearAuthenticatedClientState } from '@/lib/authSession';
import { WorklynxIcon } from '@/components/icons/WorklynxIcon';

interface StartupErrorScreenProps {
  title: string;
  message: string;
}

export function StartupErrorScreen({ title, message }: StartupErrorScreenProps) {
  async function handleSignOut() {
    await supabase.auth.signOut({ scope: 'local' }).catch(() => undefined);
    clearAuthenticatedClientState();
    window.location.assign('/login');
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4 py-10 text-foreground">
      <section className="w-full max-w-lg rounded-md border border-danger/20 bg-card p-6 shadow-sm">
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-danger-soft text-danger">
            <WorklynxIcon name="warning" size={20} />
          </div>
          <div className="min-w-0">
            <h1 className="text-xl font-semibold">{title}</h1>
            <p className="mt-2 text-sm leading-6 text-muted">{message}</p>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Button type="button" onClick={() => window.location.reload()}>
            <WorklynxIcon name="refresh" size={16} />
            Refresh
          </Button>
          <Button type="button" variant="outline" onClick={handleSignOut}>
            <WorklynxIcon name="logout" size={16} />
            Sign in again
          </Button>
        </div>
      </section>
    </main>
  );
}
